export const mockAssetDetailList = [{}];

// 更多资产详情枚举
export enum AssetDetailEnum {
  HOUSE = 'house',
  PARKING_LOT = 'parkingLot',
  CARPORT = 'carport',
}
